import React from 'react'

import { BlogType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { Carousel } from '@organisms/Carousel'
import { TitleSection } from '@organisms/TitleSection'

import { BlogCard } from './BlogCard/BlogCard'
import { Button, Link, Wrapper } from './BlogsThumbnailCards.styled'

export const BlogsThumbnailCards = ({
    blogTitle,
    viewAllLink,
    viewAllLinkLabel,
    subtitle,
    mode,
    blogDescription,
    BlogItem: items,
}: BlogType): JSX.Element => {
    return (
        <Wrapper $mode={mode}>
            <TitleSection title={blogTitle as string} subtitle={subtitle} mode={mode} description={blogDescription}>
                <Grid container>
                    <Carousel>
                        {items.map((item, i) => (
                            <BlogCard item={item} key={`blog-item-${i}`} mode={mode} />
                        ))}
                    </Carousel>
                </Grid>

                {viewAllLink && viewAllLinkLabel && (
                    <Grid container justifyContent="center" spacingTop={10}>
                        <Link to={viewAllLink}>
                            <Button>{viewAllLinkLabel}</Button>
                        </Link>
                    </Grid>
                )}
            </TitleSection>
        </Wrapper>
    )
}
